import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import { COMMON_TEXT } from '@/helpers/common-text';
import {
  FOLDER_NAME,
  BUCKET_NAME as IMAGE_BUCKET_NAME,
  MAX_UPLOAD_IMAGE_FILE_SIZE,
  QUERY_STRING_STORE,
} from '@/helpers/constants';
import { getConfigurationUrlWithParam } from '@/helpers/utility';
import { Field, FieldArray, Form, Formik, getIn } from 'formik';
import { cloneDeep, isEmpty } from 'lodash';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import {
  fetchArubaBuildingListByBranchIdList,
  fetchArubaFloorListByBuildingIdList,
  fetchBranchList,
  fetchFloorListByBranchIdList,
  fetchMerakiFloorListByNetworkIdList,
  fetchMerakiNetworkListByBranchIdList,
} from './query-request';
import { Dropdown } from 'primereact/dropdown';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import fileService from '@/services/file-service';
import Toaster from 'src/components/CustomComponent/Toaster';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class FloorSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      dataList: [],
      floorMapUrls: {},
      fetchingUrls: {},
      showImagePreview: false,
      previewImageUrl: null,
    };
    this.originalDataList = [];
    this.toastRef = React.createRef();
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  renderBackToConfigButton = () => {
    const { isLoading } = this.state;
    return (
      <Button
        label={`戻る`}
        loading={isLoading}
        className="back-button has-shadow"
        severity="secondary"
        size="small"
        onClick={() => {
          this.getData();
        }}
      />
    );
  };

  getNullFloorRelatedId = selectedFloor => {
    return typeof selectedFloor === 'object'
      ? selectedFloor.value
      : selectedFloor;
  };

  findItemChanges({ updatedArray, originalArray }) {
    const result = {
      newItemsMap: {},
      deletedItemsMap: {},
      updatedItemsMap: {},
    };

    // convert originalArray and updatedArray to a map with key is branchId and value is floorList
    const originalMap = {};
    originalArray.forEach(item => {
      originalMap[item.branchId] = item.floorList || [];
    });

    const updatedMap = {};
    updatedArray.forEach(item => {
      updatedMap[item.branchId] = item.floorList || [];
    });

    // Find deleted items
    for (let branchId in originalMap) {
      const originalFloorList = originalMap[branchId];
      const updatedFloorList = updatedMap[branchId];
      // find item that is in orgFloorList but not in floorList
      const deletedFloorList = originalFloorList.filter(
        o => !updatedFloorList.find(f => f.floorId === o.floorId)
      );
      if (deletedFloorList.length > 0) {
        result.deletedItemsMap[branchId] = deletedFloorList;
      }

      // find new item, new item is item in updatedFloorList and have null floorId
      const newFloorList = updatedFloorList.filter(o => !o.floorId);
      if (newFloorList.length > 0) {
        result.newItemsMap[branchId] = newFloorList.map(floor => ({
          ...floor,
          relatedFloorId: this.getNullFloorRelatedId(floor.relatedFloorId),
        }));
      }

      // find changed item, changed item is item that both in updatedFloorList and originalFloorList
      // and have same floorId and have different floorName or floorMap
      const changedFloorList = updatedFloorList.filter(o => {
        const relatedFloorIdValue = this.getNullFloorRelatedId(
          o.relatedFloorId
        );
        const orgItem = originalFloorList.find(
          orgItem => orgItem.floorId === o.floorId
        );
        return (
          orgItem &&
          (orgItem.floorName !== o.floorName ||
            orgItem.floorMap !== o.floorMap ||
            orgItem.floorOrder !== o.floorOrder ||
            orgItem.relatedFloorId !== relatedFloorIdValue ||
            orgItem.scaleX !== o.scaleX ||
            orgItem.scaleY !== o.scaleY)
        );
      });
      if (changedFloorList.length > 0) {
        result.updatedItemsMap[branchId] = changedFloorList.map(floor => ({
          ...floor,
          relatedFloorId: this.getNullFloorRelatedId(floor.relatedFloorId),
        }));
      }
    }
    return result;
  }

  getUpdateDataPayload = ({
    newItemsMap,
    deletedItemsMap,
    updatedItemsMap,
  }) => {
    let payload = {
      values: [],
    };
    const branchIdSet = new Set();
    if (!isEmpty(newItemsMap)) {
      Object.keys(newItemsMap).forEach(branchId => {
        branchIdSet.add(branchId);
      });
    }
    if (!isEmpty(deletedItemsMap)) {
      Object.keys(deletedItemsMap).forEach(branchId => {
        branchIdSet.add(branchId);
      });
    }
    if (!isEmpty(updatedItemsMap)) {
      Object.keys(updatedItemsMap).forEach(branchId => {
        branchIdSet.add(branchId);
      });
    }

    for (const branchId of branchIdSet) {
      const newFloors = newItemsMap?.[branchId] || [];
      const branchObject = {
        branch_id: +branchId,
        floors: [],
      };
      if (newFloors.length > 0) {
        for (const floor of newFloors) {
          branchObject.floors.push({
            floor_id: null,
            name: floor.floorName,
            floor_map: floor.floorMap,
            floor_order: floor.floorOrder,
            related_floor_id: floor.relatedFloorId,
            related_product: floor.relatedProduct,
            scale_x: floor.scaleX,
            scale_y: floor.scaleY,
          });
        }
      }

      const deletedFloors = deletedItemsMap?.[branchId] || [];
      if (deletedFloors.length > 0) {
        for (const floor of deletedFloors) {
          branchObject.floors.push({
            floor_id: floor.floorId,
            name: null,
          });
        }
      }

      const updatedFloors = updatedItemsMap?.[branchId] || [];
      if (updatedFloors.length > 0) {
        for (const floor of updatedFloors) {
          branchObject.floors.push({
            floor_id: floor.floorId,
            name: floor.floorName,
            floor_map: floor.floorMap,
            floor_order: floor.floorOrder,
            related_floor_id: floor.relatedFloorId,
            related_product: floor.relatedProduct,
            scale_x: floor.scaleX,
            scale_y: floor.scaleY,
          });
        }
      }
      payload.values.push(branchObject);
    }
    return payload;
  };

  getBuildingAndNetworkList = async branchIdList => {
    let arubaBuildingList = await fetchArubaBuildingListByBranchIdList({
      branchIdList,
    });
    arubaBuildingList = arubaBuildingList || [];
    const buildingIds = arubaBuildingList.map(item => item.building_id);
    let arubaFloors = await fetchArubaFloorListByBuildingIdList({
      buildingIds,
    });

    let merakiNetworkList = await fetchMerakiNetworkListByBranchIdList({
      branchIdList,
    });
    merakiNetworkList = merakiNetworkList || [];
    const networkIds = merakiNetworkList.map(item => item.network_identifer);
    let merakiFloors = await fetchMerakiFloorListByNetworkIdList({
      networkIds,
    });

    const result = branchIdList.reduce((acc, item) => {
      acc[item] = {
        aruba: arubaFloors
          .filter(floor =>
            arubaBuildingList.some(
              building =>
                building.branch_id === item &&
                building.building_id === floor.building_id
            )
          )
          .map(floor => ({
            value: floor.floor_identifer,
            label: floor.floor_name,
          })),
        meraki: merakiFloors
          .filter(floor =>
            merakiNetworkList.some(
              network =>
                network.branch_id === item &&
                network.network_identifer === floor.network_identifer
            )
          )
          .map(floor => ({
            value: floor.floor_identifer,
            label: floor.floor_name,
          })),
      };
      return acc;
    }, {});

    return result;
  };

  getData = async () => {
    this.setState({ isLoading: true });
    const { tenant } = this.state;
    // fetch data here
    // set time out 1 seconds
    let branchList = await fetchBranchList({ tenantId: tenant });
    branchList = branchList || [];
    const branchIdList = branchList.map(branch => branch.branch_id);
    let floorList = await fetchFloorListByBranchIdList({ branchIdList });
    floorList = floorList || [];

    let additionalInfo = await this.getBuildingAndNetworkList(branchIdList);

    branchList.forEach(branch => {
      branch.floor_list = floorList.filter(
        floor => floor.branch_id === branch.branch_id
      );
      branch.groupedOptions = [
        {
          label: '',
          value: '',
          items: [
            {
              label: 'なし',
              value: '',
            },
          ],
        },
        {
          label: 'Merakiネットワーク',
          value: 'meraki',
          items: cloneDeep(additionalInfo[branch.branch_id].meraki),
        },
        {
          label: 'Arubaサイト',
          value: 'aruba',
          items: cloneDeep(additionalInfo[branch.branch_id].aruba),
        },
      ];
    });

    const transformedBranchList = branchList.map(branch => ({
      branchId: +branch.branch_id,
      branchName: branch.branch_name,
      branchOrder: branch.branch_order,
      groupedOptions: branch.groupedOptions,
      floorList: branch.floor_list.map(floor => ({
        floorId: +floor.floor_id,
        floorName: floor.floor_name,
        branchId: floor.branch_id,
        floorMap: floor.floor_map,
        relatedFloorId: floor.related_floor_id || {
          label: 'なし',
          value: '',
        },
        relatedProduct: floor.related_product,
        floorOrder: floor.floor_order,
        scaleX: floor.scale_x ?? 0,
        scaleY: floor.scale_y ?? 0,
      })),
    }));
    this.originalDataList = cloneDeep(transformedBranchList);
    this.setState({
      dataList: cloneDeep(transformedBranchList),
    });
    this.setState({ isLoading: false });
  };

  updateFloorInfo = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsFloors({
        apiPostWorkflowRequest: {
          ...updatePayLoad,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING ERROR', error);
    }
    return { isSuccess: false };
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    const { isSuccess } = await this.updateFloorInfo({
      updatePayLoad,
    });

    if (isSuccess) {
      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        this.getData();
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  fetchFloorMapUrl = async (floorMapKey) => {
    if (!floorMapKey) return null;
    
    try {
      if (this.state.floorMapUrls[floorMapKey]) {
        return this.state.floorMapUrls[floorMapKey];
      }
      
      const url = await fileService.getFileUrl(floorMapKey, this.props.tenantId);
      
      this.setState(prevState => ({
        floorMapUrls: {
          ...prevState.floorMapUrls,
          [floorMapKey]: url
        }
      }));
      
      return url;
    } catch (error) {
      console.error('Failed to fetch floor map URL:', error);
      return null;
    }
  }

  handleImagePreview = (imageUrl) => {
    this.setState({
      showImagePreview: true,
      previewImageUrl: imageUrl,
    });
  };

  handleCloseImagePreview = () => {
    this.setState({
      showImagePreview: false,
      previewImageUrl: null,
    });
  };

  renderSettingContent() {
    const { isLoading, dataList } = this.state;

    const addNewFloor = ({ arrayHelpers, item, branchId }) => {
      arrayHelpers.push({
        floorId: '',
        floorName: '',
        branchId: branchId,
        floorOrder: item.length + 1,
        floorMap: '',
        scaleX: 0,
        scaleY: 0,
      });
    };

    const deleteAccepted = ({ arrayHelpers, index, item }) => {
      // remove for UI
      arrayHelpers.remove(index);
      // remove index
      const selectedFloorList = arrayHelpers.form.values.branches.filter(
        branch => branch.branchId === item.branchId
      )[0].floorList;
      selectedFloorList.splice(index, 1);

      // rearrange floorOrder
      selectedFloorList.map((floor, floorIndex) => {
        floor.floorOrder = floorIndex + 1;
        return '';
      });
    };

    const deleteButtonOnClicked = (e, { arrayHelpers, item, index }) => {
      const { floorId } = item;
      if (floorId) {
        confirmDialog({
          message: COMMON_TEXT.DELETE_CONFIRM_MESSAGE,
          header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
          icon: '',
          accept: () => deleteAccepted({ arrayHelpers, index, item }),
          reject: () => {},
          acceptClassName: 'p-button-danger',
          rejectClassName: 'p-button-secondary p-button-text',
          appendTo: 'self',
        });
      } else {
        deleteAccepted({ arrayHelpers, index, item });
      }
    };

    const handleSubmit = (values, { setSubmitting, errors }) => {
      if (!errors) {
        // this.updateData();
        const { deletedItemsMap, newItemsMap, updatedItemsMap } =
          this.findItemChanges({
            updatedArray: values.branches,
            originalArray: this.originalDataList,
          });

        const updatePayLoad = this.getUpdateDataPayload({
          newItemsMap,
          deletedItemsMap,
          updatedItemsMap,
        });
        const { values: payloadValues } = updatePayLoad;
        if (payloadValues.length === 0) {
          return;
        }
        this.updateData({ updatePayLoad });
      } else {
      }
    };

    const isFormFieldInvalid = ({ name, touched, errors }) => {
      const error = getIn(errors, name);
      const touch = getIn(touched, name);
      return touch && error ? 'p-invalid' : '';
    };

    const getFormErrorMessage = ({ name, touched, errors }) => {
      return isFormFieldInvalid({ name, touched, errors }) ? (
        <span className="validation-error-message">{getIn(errors, name)}</span>
      ) : (
        <></>
      );
    };

    const formSchema = Yup.object().shape({
      branches: Yup.array().of(
        Yup.object().shape({
          floorList: Yup.array().of(
            Yup.object().shape({
              floorName: Yup.string().required(COMMON_TEXT.REQUIRED),
            })
          ),
        })
      ),
    });

    const uploadFileToBucket = async ({ file, fileName }) => {
      const BUCKET_NAME = IMAGE_BUCKET_NAME.STATIC;
      const FILE_PATH = `${FOLDER_NAME.FLOOR_MAP}/${fileName}`;
      const FULL_FILE_PATH = `${BUCKET_NAME}/${FILE_PATH}`;
      try {
        // Get presigned upload URL using the new file service API
        const uploadUrl = await fileService.getFileUrl(FULL_FILE_PATH, null, 'PUT');
        
        // Upload the file directly to the presigned URL
        const uploadResponse = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        });

        if (!uploadResponse.ok) {
          throw new Error(`Upload failed with status: ${uploadResponse.status}`);
        }

        return { success: true, fileUrl: `${FULL_FILE_PATH}` };
      } catch (err) {
        console.error('Upload error:', err);
      }
      return { success: false, fileUrl: null };
    };

    const onTemplateUpload = async (event, { item, index, arrayHelpers }) => {
      const files = event.files;
      if (files.length > 1) {
        this.toastRef.current.show({
          severity: 'error',
          summary: COMMON_TEXT.UPLOAD_ERROR_MESSAGE,
          detail: COMMON_TEXT.UPLOAD_MULTIPLE_ERROR_MESSAGE,
        });
        event.options.clear();
      }
      // Iterate over each file and perform a custom upload operation
      for (let file of files) {
        // Simulate a successful file upload with a delay

        // get extension from file name
        const extension = file.name.split('.').pop();

        // generate new file name
        const newFileName = `${uuidv4()}.${extension}`;
        try {
          if (file.size > MAX_UPLOAD_IMAGE_FILE_SIZE) {
            // For example, check if file size is more than 1MB
            throw new Error(COMMON_TEXT.UPLOAD_EXCEED_MESSAGE);
          }
          const { success: isUploadSuccess, fileUrl } =
            await uploadFileToBucket({
              file,
              fileName: newFileName,
            });
          if (!isUploadSuccess) {
            throw new Error(COMMON_TEXT.UPLOAD_FAILED_MESSAGE);
          }
          // set employee image
          item['floorMap'] = fileUrl;
          arrayHelpers.replace(index, item);

          event.options.clear();
          this.toastRef.current.show({
            severity: 'success',
            summary: COMMON_TEXT.UPLOAD_MESSAGE,
            detail: COMMON_TEXT.UPLOAD_MESSAGE_SUCCESS,
          });
        } catch (error) {
          this.toastRef.current.show({
            severity: 'error',
            summary: COMMON_TEXT.UPLOAD_ERROR_MESSAGE,
            detail: error.message,
          });
          event.options.clear();
        }
      }
    };

    const onDragEnd = (result, { floorListHelpers, floors }) => {
      // dropped outside the list
      if (!result.destination) {
        return;
      }
      const sourceItem = floors[result.source.index];
      const destinationItem = floors[result.destination.index];
      sourceItem.floorOrder = result.destination.index + 1;
      destinationItem.floorOrder = result.source.index + 1;
      floorListHelpers.replace(result.source.index, destinationItem);
      floorListHelpers.replace(result.destination.index, sourceItem);
    };

    const floorItemContent = ({
      floorInfo,
      floorIndex,
      index, // branch index
      handleChange,
      setFieldValue,
      touched,
      errors,
      snapshot,
      provided,
      branch,
      floorListHelpers,
    }) => {
      const floorMapUrl = this.state.floorMapUrls[floorInfo.floorMap] || null;
      if (floorInfo.floorMap && !floorMapUrl && !this.state.fetchingUrls[floorInfo.floorMap]) {
        this.setState(prevState => ({
          fetchingUrls: {
            ...prevState.fetchingUrls,
            [floorInfo.floorMap]: true
          }
        }));
        this.fetchFloorMapUrl(floorInfo.floorMap)
          .then(url => {
            if (url) {
              this.setState(prevState => ({
                floorMapUrls: {
                  ...prevState.floorMapUrls,
                  [floorInfo.floorMap]: url
                },
                fetchingUrls: {
                  ...prevState.fetchingUrls,
                  [floorInfo.floorMap]: false
                }
              }));
            } else {
              this.setState(prevState => ({
                fetchingUrls: {
                  ...prevState.fetchingUrls,
                  [floorInfo.floorMap]: false
                }
              }));
            }
          })
          .catch(error => {
            console.error('Error fetching floor map URL:', error);
            this.setState(prevState => ({
              fetchingUrls: {
                ...prevState.fetchingUrls,
                [floorInfo.floorMap]: false
              }
            }));
          });
      }
      const getRealateProduct = (selectedValue, options) => {
        const result = options.find(option =>
          option.items.some(item => item.value === selectedValue)
        );
        if (result) {
          return result.value;
        }
        return '';
      };
      const handleChangeArubaMeraki = e => {
        const selectedValue = e.value;
        setFieldValue(
          `branches[${index}].floorList[${floorIndex}].relatedFloorId`,
          selectedValue
        );
        const product = getRealateProduct(selectedValue, branch.groupedOptions);
        setFieldValue(
          `branches[${index}].floorList[${floorIndex}].relatedProduct`,
          product
        );
      };

      // Custom item template function to add class names based on group type
      const customItemTemplate = (option) => {
        if (!option) return null;
        
        // Find which group this option belongs to
        const parentGroup = branch.groupedOptions.find(group => 
          group.items && group.items.some(item => item.value === option.value)
        );
        
        let itemClass = 'dropdown-item';
        
        if (parentGroup?.value === 'meraki') {
          itemClass += ' dropdown-item-meraki';
        } else if (parentGroup?.value === 'aruba') {
          itemClass += ' dropdown-item-aruba';
        } else {
          itemClass += ' dropdown-item-empty';
        }
        
        return (
          <div className={itemClass}>
            <span className="dropdown-item-label">{option.label}</span>
          </div>
        );
      };

      // Custom group template function to add class names based on group type
      const customGroupTemplate = (option) => {
        var labelClass = 'dropdown-group-label';
        if (option.label === '') {
          labelClass = 'dropdown-group-label-empty';
        }

        return (
          <div className={`branch-dropdown-group`}>
            <span className={labelClass}>{option.label}</span>
          </div>
        );
      };
      return (
        <>
          <div
            className={`floor-item-container${snapshot.isDragging ? ' is-dragging' : ''}`}
            key={floorIndex}
            ref={provided.innerRef}
            {...provided.draggableProps}
          >
            <div className="drag-handle-field" {...provided.dragHandleProps}>
              <img src="/assets/img/drag-handle-icon.svg" alt="Drag Handle" className="drag-handle-icon" />
            </div>
            <div className="input-text-field-container floor-name-field">
              <InputText
                id={`branches[${index}].floorList[${floorIndex}].floorName`}
                value={floorInfo.floorName}
                onChange={handleChange}
                className={`figma-input ${isFormFieldInvalid({
                  name: `branches[${index}].floorList[${floorIndex}].floorName`,
                  touched,
                  errors,
                })}`}
                placeholder="フロア名"
              />
              {getFormErrorMessage({
                name: `branches[${index}].floorList[${floorIndex}].floorName`,
                touched,
                errors,
              })}
            </div>
            <div className="input-text-field-container floor-related-field">
              <Field
                type="hidden"
                id={`branches[${index}].floorList[${floorIndex}].relatedProduct`}
                name={`branches[${index}].floorList[${floorIndex}].relatedProduct`}
                value={floorInfo.relatedProduct}
              />
              <div className="figma-dropdown">
                <Dropdown
                  id={`branches[${index}].floorList[${floorIndex}].relatedFloorId`}
                  value={floorInfo.relatedFloorId}
                  onChange={handleChangeArubaMeraki}
                  options={branch.groupedOptions}
                  optionGroupLabel="label"
                  optionGroupChildren="items"
                  className={isFormFieldInvalid({
                    name: `branches[${index}].floorList[${floorIndex}].relatedFloorId`,
                    touched,
                    errors,
                  })}
                  itemTemplate={customItemTemplate}
                  optionGroupTemplate={customGroupTemplate}
                />
              </div>
              {getFormErrorMessage({
                name: `branches[${index}].floorList[${floorIndex}].relatedFloorId`,
                touched,
                errors,
              })}
            </div>
            <div className="input-text-field-container floor-map-field">
              <div className="empl-image-preview-field">
                {floorMapUrl ? (
                  <img
                    src={floorMapUrl}
                    alt="Floor Map Preview"
                    className="floor-map-image clickable-image"
                    style={{ width: '36px', height: '36px', objectFit: 'cover'}}
                    onClick={() => this.handleImagePreview(floorMapUrl)}
                  />
                ) : (
                  <div style={{ width: '36px', height: '36px', }}></div>
                )}
              </div>
              <FileUpload
                id={`branches[${index}].floorList[${floorIndex}].floorMap`}
                mode="advanced"
                auto
                name="floorImgUpload[]"
                accept="image/*"
                chooseOptions={{
                  icon: null,
                  iconOnly: true,
                  className: 'custom-upload-button',
                }}
                customUpload
                uploadHandler={e => {
                  onTemplateUpload(e, {
                    item: floorInfo,
                    index: floorIndex,
                    arrayHelpers: floorListHelpers,
                  });
                }}
              />
              {getFormErrorMessage({
                name: `branches[${index}].floorList[${floorIndex}].floorMap`,
                touched,
                errors,
              })}
            </div>
            <div className="input-text-field-container floor-action-field">
              <Button
                type="button"
                icon={null}
                text
                severity="danger"
                className="icon-only-delete-button"
                onClick={e =>
                  deleteButtonOnClicked(e, {
                    arrayHelpers: floorListHelpers,
                    item: floorInfo,
                    index: floorIndex,
                  })
                }
              >
                <span className="delete-icon">
                  <img src="/assets/img/trash-icon.svg" alt="Delete" />
                </span>
              </Button>
            </div>
          </div>
        </>
      );
    };

    const branchRowContent = ({
      branch,
      index,
      handleChange,
      setFieldValue,
      touched,
      errors,
    }) => {
      return (
        <div className="main-row-container" key={index}>
          <div className="input-text-field-container branch-name-field">
            <div>{branch.branchName}</div>
          </div>
          <div className="input-text-field-container floorlist-field">
            <FieldArray
              name={`branches[${index}].floorList`}
              render={floorListHelpers => (
                <DragDropContext
                  onDragEnd={e =>
                    onDragEnd(e, {
                      floorListHelpers,
                      floors: branch.floorList,
                    })
                  }
                >
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {branch.floorList
                          .sort((a, b) => a.floorOrder - b.floorOrder)
                          .map((floorInfo, floorIndex) => (
                            <Draggable
                              key={floorInfo.floorOrder}
                              draggableId={`draggable-${floorInfo.floorOrder}`}
                              index={floorIndex}
                            >
                              {(provided, snapshot) =>
                                floorItemContent({
                                  floorInfo,
                                  floorIndex,
                                  index, // branch index
                                  handleChange,
                                  setFieldValue,
                                  touched,
                                  errors,
                                  snapshot,
                                  provided,
                                  branch,
                                  floorListHelpers,
                                })
                              }
                            </Draggable>
                          ))}
                        <div className="floor-item-container add-floor-button-container">
                          <Button
                            severity="secondary"
                            type="button"
                            label="追加"
                            className="add-new-button has-shadow"
                            onClick={() =>
                              addNewFloor({
                                arrayHelpers: floorListHelpers,
                                item: branch.floorList,
                                branchId: branch.branchId,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              )}
            />
          </div>
        </div>
      );
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Formik
            initialValues={{ branches: dataList }}
            validationSchema={formSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue, touched, errors }) => (
              <Form id="floor-setting-form">
                <FieldArray
                  name="branches"
                  render={arrayHelpers => (
                    <>
                      <div className="main-content">
                        <div className="main-row-container is-header">
                          <div className="branch-name-field">
                            {COMMON_TEXT.FLOOR_SETTING_HEADER1}
                          </div>
                          <div className="floorlist-field">
                            <div className="floor-name-field">
                              {COMMON_TEXT.FLOOR_SETTING_HEADER3}
                            </div>
                            <div className="floor-related-field">
                              {COMMON_TEXT.FLOOR_SETTING_HEADER4}
                            </div>
                            <div className="floor-map-field">
                              {COMMON_TEXT.FLOOR_SETTING_HEADER5}
                            </div>
                            <div className="floor-action-field"></div>
                          </div>
                        </div>
                        <div>
                          {values.branches
                            .sort((a, b) => a.branchOrder - b.branchOrder)
                            .map((branch, index) =>
                              branchRowContent({
                                branch,
                                index,
                                handleChange,
                                setFieldValue,
                                touched,
                                errors,
                              })
                            )}
                        </div>
                      </div>

                    </>
                  )}
                />
              </Form>
            )}
          </Formik>
        )}
      </>
    );
  }

  render() {
    const { showImagePreview, previewImageUrl } = this.state;
    
    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />
        <Dialog
          visible={showImagePreview}
          onHide={this.handleCloseImagePreview}
          showHeader={false}
          closable={false}
          modal={true}
          dismissableMask={true}
          style={{ width: 'auto', maxWidth: '90vw', maxHeight: '90vh' }}
          className="floor-map-preview-dialog"
        >
          {previewImageUrl && (
            <img
              src={previewImageUrl}
              alt="Floor Map Preview"
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: '100%',
                maxHeight: '85vh',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          )}
        </Dialog>
        <div className="config-container custom-config-container floor-setting-container custom-setting-config-container">
          <div className="config-title-container">
            <div className="text-left">
              <div className="title-text">{COMMON_TEXT.FLOOR_SETTING}</div>
            </div>
            <div className="grid grid-nogutter align-items-center justify-content-end">
              <SaveButton
                type="submit"
                loading={this.state.isUpdating}
                form="floor-setting-form"
                label="保存"
                iconSrc="assets/img/save-setting-icon.svg"
                iconAlt="Save"
              />
            </div>
          </div>
          <div className="config-content">
            <div className="setting-content">{this.renderSettingContent()}</div>
          </div>
        </div>
      </>
    );
  }
}

FloorSetting.propTypes = {};

export default FloorSetting;
